import axios from 'axios'
import router from '@/router'

let accountHeaderInterceptor = null

export default {
  namespaced: true,
  state: {
    me: null,
    profile: null
  },
  getters: {
    getMe(state){ return state.me }
  },
  mutations: {
    setMe(state, data) {
      // console.log('data', data)
      state.me = data.me
      state.profile = data.profile
    }
  },
  actions: {
    fetch({commit}) {
      return new Promise(async (resolve, reject) => {

        let r = router.history.current.name

        let url = `${process.env.VUE_APP_API_ENDPOINT}/me?r=${r}`;

        if (this.state.selected_location_email)
          url = url + "&selected_location_email=" + encodeURIComponent(this.state.selected_location_email);

        let these_headers = {
          'Authorization': 'Bearer ' + this.state.auth.jwt
        };

        if (this.state.auth.admin) {
          these_headers['RG-Auth-Loc-Ua-Profile'] = this.state.auth.admin_jwt_token;
        }

        if (this.state.auth.owner) {
          these_headers['RG-Auth-Loc-Ua-Profile'] = this.state.auth.owner_jwt_token;
        }
  
        try {
          let response = await axios.get(url, {
            headers: these_headers,
            timeout: 30000
          })

          if (response.status == 200) {

            // Replace the previous account handler rather than stacking stale IDs.
            if (accountHeaderInterceptor !== null) axios.interceptors.request.eject(accountHeaderInterceptor)
            accountHeaderInterceptor = axios.interceptors.request.use((config) => {
              if (config.url && config.url.startsWith(process.env.VUE_APP_API_ENDPOINT + '/')) {
                config.headers = config.headers || {}
                config.headers['RG-Auth-Loc-Ua'] = response.data.user.uuid
              }
              return config
            })

            // localStorage.clear();

            // if (localStorage.getItem('business_user'))
            //   response.data.profile = JSON.parse(localStorage.getItem('business_user'));

            commit('setMe', {
              me: response.data.user, 
              profile: response.data.profile
            });

            try {
              this.state.me.me.settings.notifications_emails = this.state.me.me.settings.notifications_emails.split(",");
            }
            catch(e) {}

            try {
              this.state.me.me.settings.notifications_phone_numbers = this.state.me.me.settings.notifications_phone_numbers.split(",");
            }
            catch(e) {}

            // If Agency logs in on main reviewgrower website, redirect them to their subdomain or domain.
            // alt = auto login token
            // if (!this.state.auth.admin) {
            //   if (window.location.origin == process.env.VUE_APP_MAIN_URL && this.state.me.me.company_type == "agency" && r != "welcome") {
            //     if (this.state.me.me.domain && this.state.me.me.domain_status == 1)
            //       window.location = window.location.protocol + '//' + this.state.me.me.domain + '/login?alt=' + btoa(this.state.auth.jwt);
            //     // else
            //     //   window.location = window.location.protocol + '//' + this.state.me.me.subdomain + '/login?alt=' + btoa(this.state.auth.jwt);

            //     return;
            //   }
            // }

            // Check subscription
            try {
              if (this.state.me.me.company_type != "admin") {
                if (!this.state.me.me.subscription) {
                  router.push("/billing");
                }
                else {
                  if (this.state.me.me.subscription.stripe_status != "active" && this.state.me.me.subscription.stripe_status != "trialing")
                    router.push("/billing");
                }
              }
            }
            catch (e) {}
            
            resolve()
            return;
          }
        } catch (error) {
          reject((error.response && error.response.data && error.response.data.message) || 'Could not load your account. Check your connection and try again.')
          return
        }
  
        reject()
  
      })
    },
    save(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me`, payload, {
            headers: {
              'Authorization': 'Bearer ' + this.state.auth.jwt
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    change_password(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/change_password`, payload, {
            headers: {
              'Authorization': 'Bearer ' + this.state.auth.jwt
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    createSubscription(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/stripe/create`, payload, {
            headers: {
              'Authorization': 'Bearer ' + this.state.auth.jwt
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    changeSubscription(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/stripe/change`, payload, {
            headers: {
              'Authorization': 'Bearer ' + this.state.auth.jwt
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    cancelSubscription(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/stripe/cancel`, payload, {
            headers: {
              'Authorization': 'Bearer ' + this.state.auth.jwt
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    }
  }

}